import { useDropdown } from "../../actions/authActions";
export default (setSelect) => {
  // Unified handler function
  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const { data: dropdowns, isLoading, isError, error } = useDropdown();
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading dropdowns: {error.message}
        </p>
      </div>
    );
  }
  const RadioValueandLable = [
    { id: 1, title: "Yes" },
    { id: 0, title: "No" },
  ];
  return { dropdowns, handleDropdwonSelect, isLoading, RadioValueandLable };
};
